import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import '@/ds/index.css';
import { queryClient } from '@/lib/query/query-client';
import { parseSearch, stringifySearch } from '@/lib/url/search-params';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // Queries own freshness; the router just calls the loaders.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  // The shell scrolls inside its main area, not the window.
  scrollToTopSelectors: ['#main'],
  parseSearch,
  stringifySearch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
